import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import {
  submitFeedback,
  type FeedbackSubmissionRequest,
  type FeedbackSubmissionResponse,
} from '../services/feedback';

export type FeedbackType = 'thought' | 'feature_wish' | 'problem' | 'general';

export const feedbackKeys = {
  root: ['feedback'] as const,
};

export const useSubmitFeedback = () => {
  return useMutation<FeedbackSubmissionResponse, Error, FeedbackSubmissionRequest>({
    mutationFn: submitFeedback,
    onSuccess: () => {
      toast.success('Thank you for your feedback!');
    },
    onError: (error) => {
      const message = error instanceof Error ? error.message : 'Failed to submit feedback.';
      toast.error(message);
    },
  });
};
